module.exports = __webpack_public_path__ + "img/syukyaku-top-003.998ef5df.jpg";